import axios from '../../axios-dashboard'
import * as actionTypes from './actionTypes'

export const fetchGcpDashboardStart = () => {
    return {
        type: actionTypes.GCP_DASHBOARD_FETCH_START
    }
};

export const fetchGcpDashboardSuccess = (dashboard, filter, filterCat, scope, plan) => {
    return {
        type: actionTypes.GCP_DASHBOARD_FETCH_SUCCESS,
        dashboard: dashboard,
        filter: filter,
        filterCat: filterCat,
        scope: scope,
        plan: plan,
    }
};

export const fetchGcpDashboardFail = (error) => {
    return {
        type: actionTypes.GCP_DASHBOARD_FETCH_FAIL,
        error: error
    }
};

export const changeGcpReservationType = (reservationType) => {
    return {
        type: actionTypes.GCP_DASHBOARD_CHANGE_RESERVATION_TYPE,
        reservationType: reservationType
    }
};

export const fetchGcpDashboard = (token, req, original, scope, prevScope, plan, prevPlan, filterCat) => {

    return dispatch => {
        if (req === original && scope === prevScope && plan === prevPlan) {
            return
        }
        if (!token) {
            return
        }
        dispatch(fetchGcpDashboardStart());
        let url = "/dashboard";
        let f = req;
        if (req instanceof Array) {
            f = req[0] / 1000 + "/" + req[1] /1000
        }
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;

        let data = {filter: f, plan: plan, csp: 'gcp'};
        if (scope && scope !== "all") {
            data.scope =  scope
        }
        axios.post(url, data)
            .then(response => {
                dispatch(fetchGcpDashboardSuccess(response.data, req, filterCat, scope, plan))
            })
            .catch(err => {
                dispatch(fetchGcpDashboardFail(err))
            })
    }
};
